// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=========================================================================================
    File Name: vxCard.scss
    Description: Styles for vx-card component. Imported in VxCard.vue file
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.vx-card {
  width: 100%;
  display: block;
  position: relative;
  transition: all 0.3s ease-in-out;
}
[dir] .vx-card {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
}
[dir] .vx-card.no-shadow {
  box-shadow: none;
}
[dir] .vx-card.card-border {
  border: 1px solid #e4e4e4;
}
.vx-card .vx-card__header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}
[dir] .vx-card .vx-card__header {
  padding: 1.5rem 1.5rem 0;
}
[dir] .vx-card .vx-card__header .vx-card__title h4 + h6 {
  margin-top: 0.3rem;
}
.vx-card .vx-card__header .vx-card__title h6 {
  font-weight: 400;
}
.vx-card .vx-card__header .vx-card__actions .vx-card__action-buttons {
  display: flex;
}
[dir=ltr] .vx-card .vx-card__header .vx-card__actions .vx-card__action-buttons .feather-icon {
  margin-left: 0.5rem;
}
[dir=rtl] .vx-card .vx-card__header .vx-card__actions .vx-card__action-buttons .feather-icon {
  margin-right: 0.5rem;
}
.vx-card .vx-card__header .vx-card__actions svg {
  transition: all 0.25s ease-out;
  height: 1rem;
  width: 1rem;
}
[dir] .vx-card .vx-card__header .vx-card__actions svg {
  cursor: pointer;
}
[dir=ltr] .vx-card .vx-card__header .vx-card__actions .rotate180 > svg {
  transform: rotate(180deg) !important;
}
[dir=rtl] .vx-card .vx-card__header .vx-card__actions .rotate180 > svg {
  transform: rotate(-180deg) !important;
}
[dir=ltr] .vx-card img.card-img-top {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
[dir=rtl] .vx-card img.card-img-top {
  border-top-right-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
}
.vx-card .vx-card__collapsible-content {
  transition: all 0.3s ease-in-out;
}
.vx-card .vx-card__collapsible-content.vs-con-loading__container {
  overflow: unset;
}
.vx-card .vx-card__collapsible-content.collapsed {
  opacity: 0;
}
[dir] .vx-card .vx-card__collapsible-content.collapsed {
  transform: scale(0.99);
}
.vx-card .vx-card__collapsible-content .card-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
}
[dir] .vx-card .vx-card__collapsible-content .card-overlay {
  padding: 1.25rem;
}
[dir=ltr] .vx-card .vx-card__collapsible-content .card-overlay {
  right: 0;
  left: 0;
}
[dir=rtl] .vx-card .vx-card__collapsible-content .card-overlay {
  left: 0;
  right: 0;
}
.vx-card .vx-card__collapsible-content .card-overlay > * {
  position: relative;
  z-index: 1;
}
.vx-card .vx-card__collapsible-content .card-overlay::after {
  position: absolute;
  content: "";
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}
[dir] .vx-card .vx-card__collapsible-content .card-overlay::after {
  margin: auto;
  background: rgba(0, 0, 0, 0.6);
}
[dir=ltr] .vx-card .vx-card__collapsible-content .card-overlay::after {
  left: 0;
  right: 0;
}
[dir=rtl] .vx-card .vx-card__collapsible-content .card-overlay::after {
  right: 0;
  left: 0;
}
[dir] .vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 1.5rem;
}
[dir] .vx-card .vx-card__collapsible-content .vx-card__body img + .vx-card__title > h4 {
  margin-top: 1.5rem;
}
.vx-card .vx-card__collapsible-content img {
  display: block;
}
.vx-card .vx-card__code-container {
  overflow: hidden;
  transition: transform 0.35s, opacity 0.15s, max-height 0.3s ease-out;
}
.vx-card .vx-card__code-container.collapsed {
  opacity: 0;
}
[dir] .vx-card .vx-card__code-container.collapsed {
  transform: translateY(100%);
}
[dir] .vx-card .vx-card__code-container .code-content {
  margin: 1.5rem;
}
.vx-card .vx-card__code-container .code-content pre[class^=language-] {
  max-height: 350px;
}
[dir] .vx-card .vx-card__code-container .code-content pre[class^=language-] {
  border-radius: 0.5rem;
  margin-bottom: 0;
}
[dir] .vx-card .vx-card__footer {
  padding: 0 1.5rem 1.5rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
